import classes from "./GlobalBanner.module.less";
import { type ReactNode } from "react";
import classnames from "classnames";

interface GlobalBannerProps {
  children: ReactNode;
  type?: "primary" | "secondary";
  icon?: ReactNode;
  className?: string;
}

const GlobalBanner = ({ type = "primary", icon, children, className }: GlobalBannerProps) => {
  return (
    <div className={classnames(classes.container, classes[type], className)}>
      {icon}
      <div>{children}</div>
    </div>
  );
};

export default GlobalBanner;
